import { render } from "./PointLog.vue?vue&type=template&id=3b3f8884&ts=true"
import script from "./PointLog.vue?vue&type=script&lang=ts"
export * from "./PointLog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__